import { render, staticRenderFns } from "./childrenages.vue?vue&type=template&id=026bfa06&"
import script from "./childrenages.vue?vue&type=script&lang=js&"
export * from "./childrenages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('026bfa06')) {
      api.createRecord('026bfa06', component.options)
    } else {
      api.reload('026bfa06', component.options)
    }
    module.hot.accept("./childrenages.vue?vue&type=template&id=026bfa06&", function () {
      api.rerender('026bfa06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4ag2xDxrAcXFM/JS/childrenages.vue"
export default component.exports